import type { QuotaStatus } from '../types';

export function QuotaBanner({ quota }: { quota: QuotaStatus }) {
  const pct = quota.limit > 0 ? Math.min((quota.used / quota.limit) * 100, 100) : 100;
  const isLow = quota.remaining <= 2;
  const isExhausted = quota.remaining <= 0;

  const barColor = isExhausted ? 'bg-red-500' : isLow ? 'bg-amber-500' : 'bg-brand-secondary';

  return (
    <div className="rounded-brand border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium text-slate-700">Monthly edit quota</span>
        <span className={isExhausted ? 'font-semibold text-red-600' : 'text-slate-500'}>
          {quota.used} / {quota.limit} changes used
        </span>
      </div>
      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-slate-100">
        <div className={`h-full rounded-full ${barColor}`} style={{ width: `${pct}%` }} />
      </div>
      {isExhausted ? (
        <p className="mt-2 text-sm text-red-600">
          Aapka monthly edit limit khatam ho gaya hai. Naye changes agle month se ya support se limit badhwane ke
          baad hi ho payenge.
        </p>
      ) : isLow ? (
        <p className="mt-2 text-sm text-amber-600">Sirf {quota.remaining} changes bache hain is mahine.</p>
      ) : (
        <p className="mt-2 text-sm text-slate-500">
          {quota.remaining} changes bache hain — resets on{' '}
          {new Date(quota.resets_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}.
        </p>
      )}
    </div>
  );
}
